import React, { useImperativeHandle, useState, useRef, useCallback } from "react";
import { Checkbox } from "@curves/ui-base";
import { isFunction } from "@util/utils";

const CheckBoxLabel = React.forwardRef((props, ref) => {
	const { value: valueProps, elementName = "", onChange: _onChange, defaultChecked = false } = props;
	const [isChecked, setChecked] = useState(defaultChecked);
	const cRef = useRef(null);

	const handleOnChange = useCallback(
		() => {
			setChecked(prev => {
				isFunction(_onChange) && _onChange(valueProps, !prev);
				return !prev;
			});
		},
		// eslint-disable-next-line
		[]
	);

	useImperativeHandle(
		ref,
		() => {
			return {
				indeterminateRef: t => cRef.current.setIndeterminate(t),
				setChecked: t => setChecked(t),
			};
		},
		// eslint-disable-next-line
		[]
	);

	return <Checkbox indeterminateRef={cRef} color="primary" onChange={handleOnChange} checked={isChecked} data-name={`${elementName}`} data-value={valueProps} />;
});

export default CheckBoxLabel;
